export const AREA_CODES = [
	"96",
	"55",
	"54",
	"53",
	"52",
	"56",
	"79",
	"27",
	"23",
	"6",
	"46",
	"74",
	"84",
	"28",
	"29",
	"47",
	"43",
	"44",
	"93",
	"3",
	"42",
	"58",
	"48",
	"57",
	"13",
	"15",
	"14",
	"12",
	"16",
	"82",
	"72",
	"99",
	"97",
	"77",
	"76",
	"95",
	"94",
	"92",
	"87",
	"89",
	"88",
	"83",
	"73",
	"49",
	"85",
	"98",
	"86",
	"78",
	"25",
	"17",
	"19",
	"22",
	"18",
	"75",
	"26",
	"59",
	"24",
	"11",
	"45",
];

export const REGION_INDEX_TO_PREFECTURE_INDEX = [ // not actually prefectures, but areas
    [0], [1], [2], [3], [4], [5], [6], [7], [8], [9], [10], [11], [12], [13], [14], [15], [16], [17], [18], [19],
    [20], [21], [22], [23], [24], [25], [26], [27], [28], [29], [30], [31], [32], [33], [34], [35], [36], [37],
    [38], [39], [40], [41], [42], [43], [44], [45], [46], [47], [48], [49], [50], [51], [52], [53], [54], [55],
    [56], [57], [58],
];

// 0x1: Hokkaido 0
// 0x2: Tohoku 1
// 0x4: Kanto 2
// 0x8: Chubu 3
// 0x10: Kansai 4
// 0x20: Chugoku 5
// 0x40: Shikoku 6
// 0x80: Kyushu 7
// 0x100: Okinawa 8

export const JAPAN_REGIONS_BITFLAG = [
    0x80,
    0x8,
    0x8,
    0x8,
    0x8,
    0x8,
    0x10,
    0x4,
    0x2,
    0x10, // 6
    0x4, // 46
    0x10, // 74
    0x20, // 84
    0x4, // 28
    0x4, // 29
    0x4, // 47
    0x4, // 43
    0x4, // 44
    0x80, // 93
    0x4, // 3
    0x4, // 42
    0x8, // 58
    0x4, // 48
    0x8, // 57
    0x1, // 13
    0x1, // 15
    0x1, // 14
    0x1, // 12
    0x1, // 16
    0x20, // 82
    0x10, // 72
    0x80, // 99
    0x80, // 97
    0x8, // 77
    0x8, // 76
    0x80, // 95
    0x80, // 94
    0x80, // 92
    0x40, // 87
    0x40, // 89
    0x40, // 88
    0x20, // 83
    0x10, // 73
    0x4, // 49
    0x20, // 85
    0x80, // 98
    0x20, // 86
    0x10, // 78
    0x8, // 25
    0x2, // 17
    0x2, // 19
    0x2, // 22
    0x2, // 18
    0x10, // 75
    0x8, // 26
    0x10, // 59
    0x2, // 24
    0x1, // 11
    0x4, // 45
];
